import React, { useEffect } from 'react';
import { reduxConnect } from '../../common';

const uninstallPageId = 'uninstallAppScreen';
const emailOptInId = 'email-opt-in-script';

interface EmailOptInDialogProps {
    emailOptInIsVisible: boolean;
    emailOptInDialogIsEnabled: boolean;
    emailOptInDialogScriptSrcUrl: string;
    pageId: string;
}

const mapStoreStateToProps = (storeState: object) => {
    const { emailOptInDialogIsEnabled, emailOptInDialogScriptSrcUrl, pageId } = storeState?.appState?.appState || {};

    return {
        emailOptInDialogIsEnabled,
        emailOptInDialogScriptSrcUrl,
        pageId
    };
};

const mapDispatchToProps = {};

export const EmailOptInDialog =  reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    pageId,
    emailOptInDialogIsEnabled,
    emailOptInDialogScriptSrcUrl }: EmailOptInDialogProps) => {

    if (pageId?.toLocaleLowerCase() === uninstallPageId.toLocaleLowerCase()) {
        return null;
    }

    useEffect(() => {
        const emailWidgetScriptTag: HTMLElement | null = document.getElementById(emailOptInId);
        if (emailOptInDialogScriptSrcUrl && emailOptInDialogIsEnabled && !emailWidgetScriptTag) { // prevent appstate bug from adding multiple scripts
            const emailOptInScript = document.createElement('script');

            emailOptInScript.id = emailOptInId;
            emailOptInScript.src = emailOptInDialogScriptSrcUrl;
            emailOptInScript.type = 'text/javascript';
            emailOptInScript.async = true;
            document.head.appendChild(emailOptInScript);
        }
    }, [emailOptInDialogIsEnabled, emailOptInDialogScriptSrcUrl]);

    return null;
});
